/* global $: false */

/**
 * Parallax Backgrounds
 */
$( document ).ready(function() {
	'use strict';

	let parallaxElements = $('*[data-parallax-background-image-url]');
	if (parallaxElements.length > 0) {
		parallaxElements.each(function() {
			let parallaxElement  = $(this);
			let parallaxImageUrl = parallaxElement.attr('data-parallax-background-image-url');

			if (parallaxImageUrl) {
				parallaxElement.css('background-image', 'url(' + parallaxImageUrl + ')');
			}
		});
	}
});
